export const serializeQuery = (form) => {
  if (form) {
    const serialized = [];
    for (let i = 0; i < form.elements.length; i += 1) {
      const field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        !field.value ||
        !field.value === "" ||
        field.type === "reset" ||
        field.type === "submit" ||
        field.type === "button"
      )
        continue;

      // If a multi-select, get all selections
      if (field.type === "select-multiple") {
        const values = [];

        for (let n = 0; n < field.options.length; n += 1) {
          if (field.options[n].selected) {
            values.push(`${encodeURIComponent(field.options[n].value)}`);
          }
        }
        const multiple = `${encodeURIComponent(field.name)}=${values}`;
        serialized.push(`${multiple}`);
      }
      // Convert field data to a query string
      else if (field.type !== "checkbox" && field.type !== "radio") {
        serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
      } else if (field.type === "checkbox") {
        if (field.checked)
          serialized.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(field.checked || "")}`
          );
      } else if (field.type === "radio") {
        if (field.checked) {
          serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
        }
      }
    }
    return serialized.join("&");
  }
  return false;
};

export const serializeObject = (form) => {
  if (form) {
    let serialized = {};
    for (let i = 0; i < form.elements.length; i += 1) {
      const field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        field.type === "file" ||
        field.type === "reset" ||
        field.type === "submit" ||
        field.type === "button"
      )
        continue;

      // If a multi-select, get all selections
      if (field.type === "select-multiple") {
        const values = [];

        for (let n = 0; n < field.options.length; n += 1) {
          if (field.options[n].selected) {
            values.push(`${encodeURIComponent(field.options[n].value)}`);
          }
        }
        serialized = { ...serialized, [field.name]: values };
      }
      // Convert field data to a query string
      else if (
        (field.type !== "checkbox" &&
          field.type !== "radio" &&
          field?.classList?.value?.indexOf("DateInput_input") === -1) ||
        field.type === "map"
      ) {
        serialized = { ...serialized, [field.name]: field.value };
      } else if (field.type === "checkbox") {
        serialized = { ...serialized, [field.name]: field.checked };
      } else if (field.type === "radio") {
        if (field.checked) {
          serialized = { ...serialized, [field.name]: field.value };
        }
      } else if (field.classList.value.indexOf("DateInput_input") !== -1 && field.value) {
        const splitDate = field.value.split("/");
        const newDateFormated = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
        serialized = { ...serialized, [field.name]: newDateFormated };
      }
    }
    return serialized;
  }
  return false;
};
